import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import {
  AvatarComponent,
  CheckboxComponent,
  OfferStatusIndicatorComponent,
} from '@core/user-interface-legacy';
import type { AnyGroup, LayoutBoardGroupHeader } from '@recruitee/views-types';
import { DefaultGroupHeaderComponent } from '@recruitee/views-ui';

@Component({
  selector: 'rt-group-header',
  imports: [
    DefaultGroupHeaderComponent,
    AvatarComponent,
    OfferStatusIndicatorComponent,
    CheckboxComponent,
  ],
  templateUrl: './group-header.component.html',
  styleUrls: ['./group-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsGroupHeaderComponent implements LayoutBoardGroupHeader {
  @Input() public group: AnyGroup;
  @Input() public selectionInGroup: LayoutBoardGroupHeader['selectionInGroup'];

  public select = output<AnyGroup>();
}
